//const BASE = import.meta.env.VITE_API_URL || 'http://localhost:3001/api/auth';
const BASE = 'https://asicflow.com/api/auth'

async function req(path, opts = {}) {
  opts.headers = opts.headers || {};
  opts.credentials = 'include'; // important to send/receive httpOnly cookies
  opts.headers['Content-Type'] = 'application/json';
  const res = await fetch(`${BASE}${path}`, opts);
  const json = await res.json().catch(() => ({}));
  return { ok: res.ok, status: res.status, data: json };
}

export const api = {
  register: (payload) => req('/register', { method: 'POST', body: JSON.stringify(payload) }),
  login: (payload) => req('/login', { method: 'POST', body: JSON.stringify(payload) }),
  logout: () => req('/logout', { method: 'POST' }),
  forgot: (payload) => req('/forgot', { method: 'POST', body: JSON.stringify(payload) }),
  reset: (payload) => req('/reset', { method: 'POST', body: JSON.stringify(payload) }),
};
